<template>
	<div>
	    <modal v-if="postmodal" class="postmodal" :class="{ 'sugg-postmodal' : seriesSuggestion && !sharePopup }" @close="postmodal = false">
	        <div slot="closeModal" class="x-msg-mdl-cls" @click="postmodal = false"></div>
	        <div slot="header"></div>
	        <div slot="body">
	        	<post-details-component v-show="!seriesSuggestion && !sharePopup"></post-details-component>
	        	<series-suggestion v-show="seriesSuggestion && !sharePopup"></series-suggestion>
	        	<div class="modal-comment" v-show="commentPopup && !sharePopup">
		        	<post-comments></post-comments>
		        </div>
		        <div class="sharepopup" v-show="sharePopup">
		        	<post-share></post-share>
		        </div>
	        </div>
	        <div slot="footer">
		       	<div class="postmodal-btm" @click="postmodal = true">
		          <ul>
		            <reaction-emoji :postReaction="postData.postReaction"></reaction-emoji>                
		            <li>
		              <img class="share-icon" src="../../assets/icon/repeat.svg" alt="share-icon" />
		              <span>14</span>
		            </li>
		            <li @click="commentpopup()">
		              <img class="comment-icon" src="../../assets/icon/message-circle.svg" alt="comment-icon" />
		              <span>74</span>
		            </li> 
		            <li @click="sharepopup()">
		              <img class="comment-icon" src="../../assets/icon/social-share.svg" alt="comment-icon" />
		              <span>Share</span>
		            </li> 
		          </ul>
		          <div class="modal-autoplay">
                    <a href="#" v-if="playAgain" class="playagain" @click="playagain()">
                        <span>Play again</span>
                    </a>
                    <a href="#" v-else>
                        <toggle-button v-model="isAutoPlay" @change="autoPlay()" style="margin-right: 5px;" :color="{checked: '#DAF7F7', unchecked: '#E9EBEF'}" :switch-color="{checked: '#00C6C6', unchecked: '#A6B2C0'}" :width="38" :height="22" />
                        <span>Autoplay</span>
                    </a>
		          </div>
			    </div>
	        </div>
	    </modal>
	</div>
</template>


<script>
	import { EventBus } from '../../main';
	export default {
		props: ['postData'],
      	name: "post-details-modal",

		data(){
			return {
      			isAutoPlay:false,
				sharePopup:false,
				commentPopup:false,
				seriesSuggestion:false,
				playAgain:false,
				postmodal:false,
	      	}
	    },


	    methods: {
	    	playagain() {
	    		this.seriesSuggestion=false;
	    		this.sharePopup=false;
	    		this.playAgain=false;
	    		this.isAutoPlay=false;
	    		EventBus.$emit('play',0);
	    	},

		    autoPlay() {
		      EventBus.$emit('autoplay',this.isAutoPlay);
		    },

	    	commentpopup(){
	    		this.commentPopup = !this.commentPopup;
	    	},

	    	sharepopup(){
	    		this.sharePopup = !this.sharePopup;
	    	},
	    },

	    created() {

	        // Badges modal
	        EventBus.$on('playagain', data => {
	            this.playAgain=data;
	        });

	        // Badges modal
	        EventBus.$on('postmodal', data => {
	            this.postmodal=data;
	        });

	        // Badges modal
	        EventBus.$on('seriesCancel', data => {
	            this.seriesSuggestion=data;
	        });

	        // Clsoe modal
	        EventBus.$on('close', data => {
	            this.postmodal=data;
	        });

	        // Clsoe modal
	        EventBus.$on('shareCancel', data => {
	            this.sharePopup=data;
	        });

	        // Clsoe modal
	        EventBus.$on('nextSeriesPlay', data => {
	            console.log(data);
	            this.playagain();
	        });
	    }

    }

</script>
